module.exports = __webpack_public_path__ + "img/box.9996735b.svg";